import Subscription from "./HubSubscription";
var HubReceiver = /** @class */ (function () {
    function HubReceiver(initializer) {
        this.subscriptions = [];
        initializer(this.onReceive.bind(this));
    }
    HubReceiver.prototype.subscribe = function (onReceive) {
        var subscription = new Subscription(this, onReceive);
        this.subscriptions.push(subscription);
        return subscription;
    };
    HubReceiver.prototype.unSubscribe = function (subscription) {
        var index = this.subscriptions.indexOf(subscription);
        this.subscriptions.splice(index, 1);
    };
    HubReceiver.prototype.onReceive = function (value) {
        for (var _i = 0, _a = this.subscriptions; _i < _a.length; _i++) {
            var subscription = _a[_i];
            subscription.onReceive(value);
        }
    };
    ;
    return HubReceiver;
}());
export default HubReceiver;
